module.exports = {
          srcSet: __webpack_public_path__ + "065b7844bd84c317662e3d16a0689e0a-2500.png"+" 2500w",
          images:[ {path: __webpack_public_path__ + "065b7844bd84c317662e3d16a0689e0a-2500.png",width: 2500,height: 634}],
          src: __webpack_public_path__ + "065b7844bd84c317662e3d16a0689e0a-2500.png",
          toString:function(){return __webpack_public_path__ + "065b7844bd84c317662e3d16a0689e0a-2500.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAADCAYAAACqPZ51AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAX0lEQVR4nDXLMQrCQBRF0T+ZgIXgCrICV5MiK3RdtpZaSCSQzNwrH7R41T0v1FAHdfx0y3033t3r43BWTtk7jInqD8azUV6N2GBZOzdhapBwSPhfUaKRJ87KRalg3TC+7u1aqNk077UAAAAASUVORK5CYII=",
          width: 2500,
          height: 634
        }